import { useState } from "react";
import { Link } from "react-router-dom";
import {
  AdjustmentsHorizontalIcon,
  Squares2X2Icon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/24/outline";
import TemplateGalleryModal from "@/onboarding/TemplateGalleryModal";

/**
 * Rendered by TabContent when a tab has no visible widgets — previously a
 * silently blank grid. Offers the two ways forward plus a guides link.
 */
export default function EmptyTabState() {
  const [galleryOpen, setGalleryOpen] = useState(false);

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="max-w-md text-center">
        <Squares2X2Icon
          className="mx-auto h-10 w-10 text-gray-400 dark:text-gray-600"
          aria-hidden="true"
        />
        <h3 className="mt-3 text-base font-semibold text-gray-900 dark:text-gray-100">
          This tab is empty
        </h3>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Add feeds and tools one at a time with{" "}
          <span className="inline-flex items-center gap-1 font-medium text-gray-700 dark:text-gray-300">
            <AdjustmentsHorizontalIcon className="h-3.5 w-3.5" />
            Manage Widgets
          </span>{" "}
          (top right), or start from a ready-made layout.
        </p>
        <div className="mt-5 flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            type="button"
            onClick={() => setGalleryOpen(true)}
            className="rounded-md bg-squawk-blue/20 border border-squawk-blue/50 px-4 py-2 text-sm font-medium text-squawk-blue hover:bg-squawk-blue/30 transition-colors"
          >
            Start from a template
          </button>
          <Link
            to="/guides#dashboard"
            className="inline-flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400 hover:text-squawk-blue transition-colors"
          >
            <QuestionMarkCircleIcon className="h-4 w-4" />
            How dashboards work
          </Link>
        </div>
      </div>

      <TemplateGalleryModal
        isOpen={galleryOpen}
        onClose={() => setGalleryOpen(false)}
      />
    </div>
  );
}
